import { BACKEND_URL_PREFIX } from '../assets/const';
import { createNotification } from '../components/Notifications/Notifications';
import { buildDefaultHeaders } from './helper';
import {
  SET_POSITIONS_LOADING,
  SET_KEYWORDS,
  SET_POSITIONS,
  SET_HINTS,
  SET_HINTS_LOADING,
  ERROR,
} from './types';
import { getError } from '../utils/getError';

// Получение списка ключевых слов
export const getKeywords = (siteId) => async (dispatch, getState) => {
  dispatch({ type: SET_POSITIONS_LOADING, payload: true });
  try {
    const url = `${BACKEND_URL_PREFIX}/keyword/${siteId}`;
    console.log('getKeywords - URL:', url);
    const response = await fetch(url, {
      method: 'GET',
      ...buildDefaultHeaders(getState),
    });
    getError({ response, dispatch });
    const data = await response.json();
    console.log('getKeywords - Response data:', data);
    dispatch({ type: SET_KEYWORDS, payload: data });
    dispatch(getKeywordsHint(siteId));
  } catch (err) {
    console.error(err);
    createNotification('error', 'Ошибка при загрузке ключевых слов');
  } finally {
    dispatch({ type: SET_POSITIONS_LOADING, payload: false });
  }
};

// Добавление нового ключевого слова
export const addKeyword = (siteId, keyword) => async (dispatch, getState) => {
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/keyword/${siteId}`, {
      method: 'POST',
      body: JSON.stringify({ keyword }),
      ...buildDefaultHeaders(getState),
    });

    getError({ response, dispatch });
    const data = await response.json();

    if (response.ok) {
      createNotification('success', `Ключевое слово "${keyword}" добавлено`);
      // обновляем Redux сразу
      const keywordsRes = await fetch(`${BACKEND_URL_PREFIX}/keyword/${siteId}`, {
        method: 'GET',
        ...buildDefaultHeaders(getState),
      });
      const keywordsData = await keywordsRes.json();
      dispatch({ type: SET_KEYWORDS, payload: keywordsData });
    } else {
      createNotification('error', data?.error || 'Ошибка при добавлении ключевого слова');
    }

    return data;
  } catch (err) {
    console.error(err);
    createNotification('error', 'Ошибка при добавлении ключевого слова');
  }
};

// Удаление ключевого слова
export const deleteKeyword = (siteId, keywordId) => async (dispatch, getState) => {
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/keyword/${siteId}/${keywordId}`, {
      method: 'DELETE',
      ...buildDefaultHeaders(getState),
    });

    getError({ response, dispatch });
    if (response.ok) {
      createNotification('success', 'Ключевое слово удалено');
      // обновляем Redux
      const keywordsRes = await fetch(`${BACKEND_URL_PREFIX}/keyword/${siteId}`, {
        method: 'GET',
        ...buildDefaultHeaders(getState),
      });
      const keywordsData = await keywordsRes.json();
      dispatch({ type: SET_KEYWORDS, payload: keywordsData });
    } else {
      createNotification('error', 'Ошибка при удалении');
    }
  } catch (err) {
    console.error(err);
    createNotification('error', 'Ошибка при удалении');
  }
};

// Получение данных о позициях по конкретному ключевому слову
export const getPositionDataSingle =
  (siteId, dateFrom, dateTo, provider, keywordId) => async (dispatch, getState) => {
    dispatch({ type: SET_POSITIONS_LOADING, payload: true });

    try {
      const url = `${BACKEND_URL_PREFIX}/keyword/${siteId}/${keywordId}?provider=${provider}&date_from=${dateFrom}&date_to=${dateTo}`;
      console.log('getPositionDataSingle - URL:', url);
      const response = await fetch(url, {
        method: 'GET',
        ...buildDefaultHeaders(getState),
      });

      getError({ response, dispatch });
      const data = await response.json();
      console.log('getPositionDataSingle - Response data:', data);

      dispatch({
        type: SET_POSITIONS,
        payload: {
          type: 'single',
          provider,
          ...data,
        },
      });
    } catch (err) {
      createNotification('error', 'Ошибка при загрузке данных по ключевому слову');

      dispatch({ type: SET_POSITIONS, payload: {} });
    } finally {
      dispatch({ type: SET_POSITIONS_LOADING, payload: false });
    }
  };

const FILTER_MAP = {
  top3: 'top_3',
  top10: 'top_10',
  top30: 'top_30',
  top100: 'top_100',
  top100plus: 'top_100_plus',
  improved: 'improved_rating',
  worsened: 'worsened_rating',
  visibility: 'visibility',
};

export const getPositionDataAll =
  (siteId, dateFrom, dateTo, provider, filter = null) => async (dispatch, getState) => {
    dispatch({ type: SET_POSITIONS_LOADING, payload: true });

    try {
      const serverFilter = filter ? FILTER_MAP[filter] : null;
      const filterParam = serverFilter ? `&filter=${serverFilter}` : '';
      const url = `${BACKEND_URL_PREFIX}/keyword/${siteId}/positions?provider=${provider}&date_from=${dateFrom}&date_to=${dateTo}${filterParam}`;
      console.log('getPositionDataAll - URL:', url);
      const res = await fetch(url, {
        method: 'GET',
        ...buildDefaultHeaders(getState),
      });

      const data = await res.json();
      console.log('getPositionDataAll - Response data:', data);
      dispatch({
        type: SET_POSITIONS,
        payload: data,
      });
    } catch (err) {
      createNotification('error', 'Ошибка при загрузке всех позиций');
      dispatch({ type: SET_POSITIONS, payload: [] });
    } finally {
      dispatch({ type: SET_POSITIONS_LOADING, payload: false });
    }
  };

export const postExcelKeywords = (siteId, file) => async (dispatch, getState) => {
  if (!file) {
    createNotification('error', 'Выберите файл');
    return false;
  }

  dispatch({ type: SET_HINTS_LOADING, payload: true });

  const token = getState()?.auth?.token;
  const formData = new FormData();
  formData.append('file', file);

  try {
    await fetch(`${BACKEND_URL_PREFIX}/keyword/${siteId}/excel`, {
      method: 'POST',
      body: formData,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    return true;
  } catch (err) {

    console.log(err, 'err');
    createNotification('error', 'Ошибка при отправке excel файла!');
    return false;

  } finally {
    dispatch({ type: SET_HINTS_LOADING, payload: false });
  }
};

export const downloadExcelKeywords = (siteId) => async (dispatch, getState) => {
  dispatch({ type: SET_HINTS_LOADING, payload: true });

  const token = getState()?.auth?.token;

  try {
    const res = await fetch(`${BACKEND_URL_PREFIX}/keyword/${siteId}/excel`, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });


    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'keywords.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    return true;

  } catch (err) {

    console.log(err, 'err');
    createNotification('error', 'Ошибка при получении excel файла!');
    return false;

  } finally {
    dispatch({ type: SET_HINTS_LOADING, payload: false });
  }
};

// Получение списка возможных ключевых слов
export const getKeywordsHint = (siteId) => async (dispatch, getState) => {
  dispatch({ type: SET_HINTS_LOADING, payload: true });
  try {
    const res = await fetch(`${BACKEND_URL_PREFIX}/keyword/${siteId}/hint`, {
      method: 'GET',
      ...buildDefaultHeaders(getState),
    });
    const data = await res.json();
    dispatch({ type: SET_HINTS, payload: data });
  } catch (err) {
    createNotification('error', 'Ошибка при загрузке ключевых слов');
  } finally {
    dispatch({ type: SET_HINTS_LOADING, payload: false });
  }
};
